export default __webpack_public_path__ + "static/media/Button_Zoom.697c5523.svg";